<template>
  <div class="loading">
    <div class="logo">
      <div class="blue"></div>
      <div class="gray"></div>
    </div>
  </div>
</template>

<script>
export default {
  name:'loading',
  data(){
    return{

    }
  },
  mounted() {
    setTimeout(()=>{
      const  link='./home.html'
      window.open(link,'_self')
    },800)
  }
};
</script>

<style scoped>
.loading{
  position: relative;
  width: 100%;
  height: 100vh;
  z-index: 9999;
  background-color:#fff;
}
.loading .logo{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 132px;
  height: 32px;
  overflow: hidden;
}
.loading .blue{
  position: absolute;
  top: 0;
  left: 0;
  width: 132px;
  height: 32px;
  background: url('../assets/rj/gray.png') no-repeat left;
  z-index: 3;
  animation: logo 2s infinite linear;
}
.loading .gray{
  position: absolute;
  top: 0;
  left: 0;
  width: 132px;
  height: 32px;
  background: url('../assets/rj/topLogo.png')no-repeat left;
  z-index: 2;
}

@keyframes logo {
  0% {
    width:0;
  }
  100% {
    width:360px;
  }
}
</style>


